export const CREATE_GAME = 'CREATE_GAME';
export const CREATE_GAME_SUCCESS = 'CREATE_GAME_SUCCESS';
export const DELETE_GAMES = 'DELETE_GAMES';
export const GET_GAMES = 'GET_GAMES';
export const SET_GAMES = 'SET_GAMES';
